import Cookies from "js-cookie";
import React from "react";
import { useTranslation } from "react-i18next";
import { goToWebsite } from "../../../../utils/goToWebsite";
import { Icon } from "../../../Icon/Icon";
import "./AddApplicationModalContent.css";

export /**
 *
 *
 * @param {object} props
 * @prop {string} appId
 * @prop {function} setAppId
 * @prop {string} appName
 * @prop {function} setAppName
 * @prop {object} props.app
 * @prop {string} props.app.id
 * @prop {string} props.app.name
 * @prop {boolean} props.app.supportAccess
 * @prop {string} props.app.type
 * @prop {string} distributorId
 * @return {*}
 */
const AddApplicationModalContent = ({
  appId,
  setAppId,
  appName,
  setAppName,
  app,
  distributorId,
}) => {
  const { t } = useTranslation();
  return (
    <div className="AddApplicationModalContent">
      <div className="AddApplicationModalContent__details">
        <div className="AddApplicationModalContent__app-id">
          <label className="AddApplicationModalContent__app-label">
            {t("Application ID")}
          </label>
          <input
            className="AddApplicationModalContent__input"
            value={appId}
            onChange={(e) => setAppId(e.target.value)}
          />
        </div>
        <div className="AddApplicationModalContent__app-name">
          <label className="AddApplicationModalContent__app-label">
            {t("Application name")}
          </label>
          <input
            className="AddApplicationModalContent__input"
            value={appName}
            onChange={(e) => setAppName(e.target.value)}
          />
        </div>
        <div className="AddApplicationModalContent__external">
          <div
            className="AddApplicationModalContent__external-button"
            onClick={() =>
              goToWebsite(getAppUrlFromAppName(app, distributorId))
            }
          >
            <div className="AddApplicationModalContent__external-text">
              {t("Go to app")}
            </div>
            <div className="AddApplicationModalContent__external-icon">
              <Icon name="iconExternal" width={15} height={18} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const getAppUrlFromAppName = (app, distributorId) => {
  switch (app) {
    case "WORKFLOW":
      return (
        process.env.REACT_APP_WORKFLOW_URL + "/?distributor_id=" + distributorId
      );

    case "INVENTORY":
      return `${
        process.env.REACT_APP_INVENTORY_URL
      }/?distributor_id=${distributorId}&access_level=${Cookies.get(
        "access_level"
      )}`;

    default:
      return "#";
  }
};
